import { httpGetAuthorized } from "components/utils/http";
import useSWRImmutable from "swr/immutable";
import { ReferenceResult } from "types/ReferenceResult";

export const useEquipmentValidationTypes = (): [validationTypes: ReferenceResult[], isLoading: boolean, error: any] => {
    const url = process.env.REACT_APP_REFERENCE_ENDPOINT + "?type=equipmentValidation&outputType=id";
    const { data, error, isLoading } = useSWRImmutable(url, httpGetAuthorized);

    return [data?.referenceResults, isLoading, error];
};
